export default function FindingCategoryDirective() {
  return {
    template: require('./finding-category.html'),
    scope: {
      auditId: '=',
      findingCategory: '=',
      auditIsActive: '=',
      canEdit: '=',
      canDelete: '=',
    },
    controller: 'FindingCategoryController',
    controllerAs: 'findingCategoryVM',
    bindToController: true,
    replace: true
  };
}
